import checkIsValueEmpty from "./checkIsValueEmpty";

export default function capitalizeFirstLetter(string) {

    if (checkIsValueEmpty(string)) { return "" }

    return string.charAt(0).toUpperCase() + string.slice(1);
}